import React from 'react'
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router'
import { UserRoleTypes } from '../../utils/enums/userRoleTypes';
import MainPage from './MainPage'
import TransactionDetail from './TransactionDetail';
import TransactionDetailSucess from './TransactionDetail/detail';

const TransactionPage = () => {
  const { url } = useRouteMatch();
  const { user } = useSelector(state => state.auth);

  return (
    <div>
      <Switch>
        <Route exact path={url} component={MainPage} />
        {
          user.role === UserRoleTypes.SUPERVISOR &&
          <Route path={`${url}/:id/:code/detail`} component={TransactionDetail} />
        }
        {
          <Route path={`${url}/:id/:code/detail-success`} component={TransactionDetailSucess} />
        }
        {/* <TransactionDetailSucess></TransactionDetailSucess> */}
        <Redirect to={url} />
      </Switch>
    </div>
  )
}

export default TransactionPage
